import React, { useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Avatar } from './UiKit/Avatar';
import { AvatarName } from './UiKit/AvatarName';
import { ChatsNotifications } from './UiKit/ChatsNotifications';
import { DropDown, DropDownDivider } from './UiKit/DropDown';
import { Notifications } from './UiKit/Notifications';
import { WithVersion } from './UiKit/VersionToggler';
import { PlanetIco } from './UiKit/Planets';
import { AUTH_MODAL_LOGIN, openAuth } from './utilsAuth';
import { clearLocalSession } from './utilsSocial';
import { Icon } from './UiKit/Icon';


export function UserPanel({ userId, mode = 'hd' }) {

  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;

  const location = useLocation();
  const isStudy = location.pathname.includes('study');

  return (
    <>
      <div className={`x_0_right ${isStudy ? 'x_0_right--study' : ''}`}>

        {Boolean(context.me) && <ChatsNotifications />}

        {Boolean(context.me) && <Notifications />}

        <DropDown
          id='userdrop'
          customDrop={(handleClose = () => void (0)) => <div className="x_settings_pop">
            <div className="x_settings_section">
              <div className="x_settings_section_title">
                {$ui('personal_settings')}
              </div>


              {Boolean(context.me) && <div className="x_settings_li">
                <div className="x_settings_action"
                  style={{
                    columnGap: '.4em',
                    marginLeft: '-0.4em',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/u/${context.me.user.token}/info`);
                    handleClose()
                  }}
                >
                  <Avatar
                    avatar={context.me.avatar}
                    style={{
                      fontSize: '0.8em',
                      marginTop: '.04em',
                      marginLeft: '.04em',
                      // marginRight: '-0.3em',
                      // marginTop: '-0.3em',
                      // width: '3em',
                      // height: '3em'
                    }}
                    size='sm'
                  />
                  <div className="x_choose_filter_title x_choose_filter_title--name">
                    <AvatarName avatar={context.me.avatar} />
                  </div>

                </div>


                <a
                  className="x_button x_button--ghost"
                  href='/auth0/logout'
                  onClick={clearLocalSession}
                >
                  <div className="t_icon t_icon--20">
                    <div>logout</div>
                  </div>
                </a>

              </div>}






              {!Boolean(context.me) && <div className="x_settings_li">

                <a
                  className="x_settings_action"
                  href='/auth0/login'
                  onClick={openAuth(context.setState.setAuthModal, AUTH_MODAL_LOGIN)}
                >
                  <Icon>
                    login
                  </Icon>

                  {$ui('login')}
                </a>

              </div>}


              {Boolean(context.me) && <div className="x_settings_li">
                <div className={`x_settings_action`}
                  onClick={() => {
                    navigate(`/u/${context.me.user.token}/settings`)
                  }}
                >
                  <div className="t_icon">
                    settings
                  </div>
                  <div>
                    <div className="x_choose_filter_title">{$ui('settings_personal')}</div>
                  </div>
                </div>
              </div>}


            </div>



            <div className="x_settings_section">
              <div className="x_settings_section_title">
                {$ui('language')}
              </div>

              <div className="x_settings_ul expanded">


                <div className="x_settings_li">
                  <div className={`x_settings_action ${context.language === 'en' ? 'active' : ''}`}
                    onClick={() => {
                      context.setLanguage('en')
                      // handleClose()
                    }}
                  >
                    <div className="t_icon">
                      <div>language</div>
                    </div>
                    <div>
                      <div className="x_choose_filter_title">English</div>
                    </div>
                    <div className="x_settings_right">
                      <div className={`x_settings_check ${context.language === 'en' ? 'active' : ''}`}>
                        <div className="t_icon t_icon--20">
                          {context.language === 'en' ? 'radio_button_checked' : 'radio_button_unchecked'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="x_settings_li">
                  <div className={`x_settings_action ${context.language === 'ru' ? 'active' : ''}`}
                    onClick={() => {
                      context.setLanguage('ru')
                      // handleClose()
                    }}
                  >
                    <div className="t_icon">
                      language
                    </div>
                    <div>
                      <div className="x_choose_filter_title">Русcкий</div>
                    </div>
                    <div className="x_settings_right">

                      <div className={`x_settings_check ${context.language === 'ru' ? 'active' : ''}`}>
                        <div className="t_icon t_icon--20">
                          {context.language === 'ru' ? 'radio_button_checked' : 'radio_button_unchecked'}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <WithVersion>
              <div className="x_settings_section">
                <div className="x_settings_section_title">
                  {$ui('settings_ui_theme')}
                </div>

                <div className="x_settings_ul expanded">
                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.uiTheme === 'system' ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setUiTheme('system')
                      }}
                    >
                      <div className="t_icon">
                        <div>contrast</div>
                      </div>
                      <div>
                        <div className="x_choose_filter_title">{$ui('settings_ui_theme_system')}</div>
                      </div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.uiTheme === 'system' ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.uiTheme === 'system' ? 'radio_button_checked' : 'radio_button_unchecked'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.uiTheme === 'light' ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setUiTheme('light')
                      }}
                    >
                      <div className="t_icon">
                        <div>light_mode</div>
                      </div>
                      <div>
                        <div className="x_choose_filter_title">{$ui('settings_ui_theme_light')}</div>
                      </div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.uiTheme === 'light' ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.uiTheme === 'light' ? 'radio_button_checked' : 'radio_button_unchecked'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.uiTheme === 'dark' ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setUiTheme('dark')
                      }}
                    >
                      <div className="t_icon">
                        <div>dark_mode</div>
                      </div>
                      <div>
                        <div className="x_choose_filter_title">{$ui('settings_ui_theme_dark')}</div>
                      </div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.uiTheme === 'dark' ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.uiTheme === 'dark' ? 'radio_button_checked' : 'radio_button_unchecked'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </WithVersion>


            {mode === 'hd' && <div className="x_settings_section">
              <div className="x_settings_section_title">
                {$ui('settings')}
              </div>

              <div className="x_settings_ul expanded">
                <div className="x_settings_li">
                  <div
                    className={`x_settings_action ${context.state.hideNames ? 'active' : ''}`}
                    onClick={() => {
                      context.setState.setHideNames(prev => !prev)
                      // handleClose()
                    }}
                  >
                    <div className="t_icon">
                      <div>visibility_off</div>
                    </div>
                    <div>
                      <div className="x_choose_filter_title">{$ui('view_options_privacy_names')}</div>
                    </div>
                    <div className="x_settings_right">

                      <div className={`x_settings_check ${context.state.hideNames ? 'active' : ''}`}>
                        <div className="t_icon t_icon--20">
                          {context.state.hideNames ? 'toggle_on' : 'toggle_off'}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              {mode === 'hd' && <div className="x_settings_ul expanded">
                <div className="x_settings_li">
                  <div
                    className={`x_settings_action ${context.state.version === 'β' ? 'active' : ''}`}
                    onClick={() => {
                      context.setState.setVersion(prev => prev === '' ? 'β' : '')
                      // handleClose()
                    }}
                  >
                    <div className="t_icon">
                      <div>science</div>
                    </div>
                    <div>
                      <div className="x_choose_filter_title">
                        {$ui('beta_toggler')}
                      </div>
                    </div>
                    <div className="x_settings_right">
                      <div className={`x_settings_check ${context.state.version === 'β' ? 'active' : ''}`}>
                        <div className="t_icon t_icon--20">
                          {context.state.version === 'β' ? 'toggle_on' : 'toggle_off'}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {context.state.astroShown && <WithVersion>
                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.astroShown ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setAstroShown(prev => !prev)
                        // handleClose()
                      }}
                    >
                      <div className="t_icon">
                        <div>star</div>
                      </div>
                      <div className="x_choose_filter_title">{$ui('settings_astro')}</div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.astroShown ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.astroShown ? 'toggle_on' : 'toggle_off'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </WithVersion>}

                {context.state.jyotishShown && <WithVersion>
                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.jyotishShown ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setJyotishShown(prev => !prev)
                        // handleClose()
                      }}
                    >
                      <div className="t_icon">
                        <div>star</div>
                      </div>
                      <div className="x_choose_filter_title">{$ui('jyotish_title')} (beta)</div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.jyotishShown ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.jyotishShown ? 'toggle_on' : 'toggle_off'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </WithVersion>}




                {/* <WithVersion>
                  <div className="x_settings_li">
                    <div className={`x_settings_action ${context.state.astroShown ? 'active' : ''}`}
                      onClick={() => {
                        context.setState.setNumeroShown(prev => !prev)
                        // handleClose()
                      }}
                    >
                      <div className="t_icon">
                        <div>numbers</div>
                      </div>
                      <div className="x_choose_filter_title">{$ui('settings_numero')}</div>
                      <div className="x_settings_right">
                        <div className={`x_settings_check ${context.state.numeroShown ? 'active' : ''}`}>
                          <div className="t_icon t_icon--20">
                            {context.state.numeroShown ? 'toggle_on' : 'toggle_off'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </WithVersion> */}

              </div>}



            </div>}


            

            {mode === 'hd' && Boolean(context.me) && <a className="x_settings_action" href={`/yoni/${context.me?.user?.token}?reveal=true`}>
              <PlanetIco planet="Moon" color="var(--ui-text-color)" />
              <div className="x_choose_filter_title">{$ui('settings_yoni_link')} (beta)</div>
            </a>}

            {mode === 'hd' && !context.me && <a className="x_settings_action" href={`/yoni/`} style={{ color: 'var(--ui-text-color)' }}>
              <PlanetIco planet="Moon" color="var(--ui-text-color)" />
              <div className="x_choose_filter_title">{$ui('settings_yoni_link')}</div>
            </a>}

            {mode === 'yoni' && <DropDownDivider />}

            {mode === 'yoni' && Boolean(context.me) && <a className="x_settings_action" href={`/u/${context.me?.user?.token}`}>
              <div className="x_choose_filter_title">{$ui('human_design')}</div>
            </a>}

            {mode === 'hd' && !context.me && <a className="x_settings_action" href={`/`} style={{ color: 'var(--ui-text-color)' }}>
              <div className="x_choose_filter_title">{$ui('human_design')}</div>
            </a>}


          </div>}
        >




          <div className="x_user0">

            {context.state.hideNames && <div className="x_noti0 x_noti0--number">
              <div className="x_noti0_number">
                <div className="t_icon">visibility_off</div>
              </div>
            </div>}

            <div className="t_icon t_icon--60">
              menu
            </div>
          </div>

        </DropDown>



      </div>

    </>
  )
}